const FilterDtm = {
  updateFilterDtm: (filterName, filterType) => {
    let parentKeyToUpdateDtm = filterName;
    if (parentKeyToUpdateDtm?.indexOf('_id') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace(/_/g, '').replace('id', '');
    } else if (parentKeyToUpdateDtm?.indexOf('lenskart') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.replace('lenskart_', '');
    } else if (parentKeyToUpdateDtm?.indexOf('price') !== -1) {
      parentKeyToUpdateDtm = parentKeyToUpdateDtm.concat('range');
    }
    if (filterType) window.dtm.filterType = 'clear all';

    window.dtm[parentKeyToUpdateDtm] = 'clear';
  },
  updateCategoryDtm: (categoryData, dtmArg) => {
    let subC = '';
    const { userInfo, login, sort, filter } = dtmArg;
    const bCrumbArr =
      categoryData.breadcrumb && categoryData.breadcrumb.length ? categoryData.breadcrumb : [];
    const categoryType = categoryData.categoryType ? categoryData.categoryType.toLowerCase() : '';
    bCrumbArr.forEach(data => {
      if (data) {
        subC += `${data.label}-`;
      }
    });
    if (window.dtm !== undefined) {
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.allPage('listing page');
        window.dtm.LenskartRewamp.Listing.load.listing(
          categoryType,
          subC ? subC.slice(0, -1) : categoryType,
          filter,
          sort.toLowerCase(),
          login,
          login ? userInfo.result.id : '',
          dtmArg.obj
        );
      }
    }
  },
};

export default FilterDtm;
